import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enLocale from './localization/locales/en';

const resources = {
  en: { translation: enLocale },
};

const options = {
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
};

i18n.use(initReactI18next).init(options);

export default i18n;
